import { SELECIONAR_VALOR_ACRESCIMO_PASSAGEM_CALCULADO } from '../types';

export default function selecionarAcrescimoPassagemCalculado (acrescimoPassagem) {
  return {
    type: SELECIONAR_VALOR_ACRESCIMO_PASSAGEM_CALCULADO,
    payload: acrescimoPassagem
  }
}
